import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { CommonCommunicationService } from '../services/commonCommunication.service';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable()
export class RefreshInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private ccs: CommonCommunicationService,
    private router: Router,
    private storageService: StorageService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && error.error?.message === 'jwt expired') {
          return this.handle401Error(req, next);
        }
        if (error.status === 400 && 
            error.error?.error === 'Invalid refresh token' && 
            error.error?.msg === 'Refresh token does not exist in the database') {
          this.logout();
          return throwError(error);
        }
        return throwError(error);
      })
    );
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.authService.refreshToken()).pipe(
      switchMap((result: { token: string, tokenExpiresAt: string, userId: string }) => {
        let accessToken = result.token;
        this.ccs.setJwtToken(accessToken);
        let accessTokenString = JSON.stringify(accessToken);
        localStorage.setItem('token', accessTokenString);

        const clonedRequest = req.clone({
          setHeaders: {
            "X-Access-Token": `${result.token}`,
            "user-id": result.userId
          }
        });

        return next.handle(clonedRequest);
      }),
      catchError(err => {
        if (err.status === 400 && 
            err.error?.error === 'Invalid refresh token' && 
            err.error?.msg === 'Refresh token does not exist in the database') {
          this.logout();
        }
        return throwError(err);
      })
    );
  }

  private logout() {
    this.storageService.clear();
    this.router.navigate(['/auth/login']);
  }
}